var map = {
	"./prize_1.png": "HcUp",
	"./prize_2.png": "NRA1",
	"./prize_5.png": "qqrV",
	"./prize_title.png": "Pq8M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "otML";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterOlympics/dialog ^\.\/prize_.*\.png$
// module id = otML
// module chunks = 33